import React from 'react';
import { BarChartIcon, PieChartIcon, DownloadIcon } from 'lucide-react';
import Card from '../../components/ui/Card';
const CashbackReports: React.FC = () => {
  return <div className="space-y-6" data-id="element-3542">
      <div className="flex justify-between items-center" data-id="element-3543">
        <div data-id="element-3544">
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-3545">
            Cashback Reports
          </h1>
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400" data-id="element-3546">
            Detailed analytics on campaign performance and budget utilization
          </p>
        </div>
        <div className="flex space-x-2" data-id="element-3547">
          <select className="rounded-md border-gray-300 shadow-sm text-sm" data-id="element-3548">
            <option data-id="element-3549">Last 30 Days</option>
            <option data-id="element-3550">Last Quarter</option>
            <option data-id="element-3551">Year to Date</option>
          </select>
          <button className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-md shadow-sm text-sm font-medium hover:bg-blue-700" data-id="element-3552">
            <DownloadIcon className="h-4 w-4 mr-2" data-id="element-3553" />
            Download PDF
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-3554">
        <Card title="Budget Utilization by Campaign" data-id="element-3555">
          <div className="h-64 flex items-center justify-center bg-gray-50 rounded-md border border-dashed border-gray-300" data-id="element-3556">
            <div className="text-center text-gray-500" data-id="element-3557">
              <BarChartIcon className="h-10 w-10 mx-auto mb-2 opacity-50" data-id="element-3558" />
              <p data-id="element-3559">Chart Visualization Placeholder</p>
            </div>
          </div>
        </Card>

        <Card title="Payout Distribution by Region" data-id="element-3560">
          <div className="h-64 flex items-center justify-center bg-gray-50 rounded-md border border-dashed border-gray-300" data-id="element-3561">
            <div className="text-center text-gray-500" data-id="element-3562">
              <PieChartIcon className="h-10 w-10 mx-auto mb-2 opacity-50" data-id="element-3563" />
              <p data-id="element-3564">Map/Pie Chart Placeholder</p>
            </div>
          </div>
        </Card>
      </div>

      <Card title="Top Performing Merchants" data-id="element-3565">
        <div className="overflow-x-auto" data-id="element-3566">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-3567">
            <thead className="bg-gray-50" data-id="element-3568">
              <tr data-id="element-3569">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-3570">
                  Merchant
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-3571">
                  Campaigns Joined
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-3572">
                  Total Cashback Earned
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-3573">
                  Transaction Volume Growth
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-3574">
              {[1, 2, 3, 4, 5].map(i => <tr key={i} data-id="element-3575">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-3576">
                    Merchant {i}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-3577">
                    {Math.floor(Math.random() * 5) + 1}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-3578">
                    PKR {(Math.random() * 50000).toFixed(0)}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-green-600" data-id="element-3579">
                    +{Math.floor(Math.random() * 20) + 5}%
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>
    </div>;
};
export default CashbackReports;